import { DataViewConfig, TableViewConfig } from '@creditsights/styleguide-web';
import { RouteToCallback } from '@creditsights/styleguide-web/components/DataView';
import { MouseEvent } from 'react';
import { GhostLinkRenderer } from '../../../../components/formatters';
import { COVERAGE_COLUMN_WIDTH, TICKER_COLUMN_WIDTH } from '../../../../utils/columnConfigConstants';
import { IssuerSearchResultItemDto } from '../../../../services/dtos/issuer/issuerSearchResult.dto';
import { getIssuerRoute } from '../../../../utils/navigationUtils';
import CompanyCoverageRenderer from './renderers/CompanyCoverageRenderer';
import CompanyNameDescriptionRenderer from './renderers/CompanyNameDescriptionRenderer';
import CompanyLinkRenderer from './renderers/CompanyLinkRenderer';

const companyTickerRendererProps = {
  getLink: (item: IssuerSearchResultItemDto): string => getIssuerRoute(item.tagId),
  stopMouseUpPropagation: true,
  isOpenInNewTab: false,
  isHidden: (item) => !item.businessDescription,
};

const companiesColumnsConfig = (cellClassName: string): TableViewConfig => {
  const routeToCallback: RouteToCallback = (tagId) => getIssuerRoute(tagId ? tagId?.toString() : '');
  const getIdKey = () => 'tagId';

  return {
    columns: [
      {
        dataKey: 'displayName',
        cellClassname: cellClassName,
        cellLinkRenderer: GhostLinkRenderer,
        cellDataRenderer: CompanyNameDescriptionRenderer,
        dataViewItemConfiguration: { getIdKey, routeToCallback },
      },
      {
        dataKey: 'displayTicker',
        cellClassname: cellClassName,
        cellDataRenderer: CompanyLinkRenderer,
        cellRendererProps: companyTickerRendererProps,
        width: TICKER_COLUMN_WIDTH,
      },
      {
        dataKey: 'coverageLabels',
        cellClassname: cellClassName,
        cellDataRenderer: CompanyCoverageRenderer,
        width: COVERAGE_COLUMN_WIDTH,
      },
    ],
  };
};

export const viewConfig = (
  onCompanyClick: (company: IssuerSearchResultItemDto, event: MouseEvent<HTMLElement>) => void,
  cellClassName: string
): DataViewConfig<IssuerSearchResultItemDto> => ({
  tableViewConfig: companiesColumnsConfig(cellClassName),
  onRowMouseUp: onCompanyClick,
});
